export const QUERY_PAGE_SIZE_MIN = 100;
export const QUERY_PAGE_SIZE_MAX = 1000000;
export const QUERY_PAGE_SIZE_WORKFLOW_OPTIONS = [
    'timebased.asset',
    'timebased.contains',
    'timebased.f2dMilestone',
    'timebased.assemblyRef',
    'png.mfgProduct',
    'png.modelChange',
    'png.documentContains',
    'png.meRevision',
    'png.mfgProductContains',
    'png.lifecycleRevision',
    'customProperties.customProperties',
    'customProperties.customPropertiesVersionLess',
];
export const DEFAULT_QUERY_PAGE_SIZE_WORKFLOW = 'png.mfgProduct';
const WORKFLOW_KEY_SET = new Set(QUERY_PAGE_SIZE_WORKFLOW_OPTIONS);
const isBlankRow = (row) => row.pageSize.trim() === '';
export function validateQueryPageSizeRows(rows) {
    const seen = new Set();
    return rows.map((row) => {
        if (isBlankRow(row))
            return {};
        const errors = {};
        const key = row.workflowKey.trim();
        if (!WORKFLOW_KEY_SET.has(key)) {
            errors.workflowKey = 'Select a workflow from the list';
        }
        else if (seen.has(key)) {
            errors.workflowKey = 'Duplicate workflow';
        }
        seen.add(key);
        const raw = row.pageSize.trim();
        const size = Number(raw);
        if (!/^\d+$/.test(raw) ||
            !Number.isInteger(size) ||
            size < QUERY_PAGE_SIZE_MIN ||
            size > QUERY_PAGE_SIZE_MAX) {
            errors.pageSize = `Integer ${QUERY_PAGE_SIZE_MIN}–${QUERY_PAGE_SIZE_MAX.toLocaleString('en-US')}`;
        }
        return errors;
    });
}
export const hasQueryPageSizeErrors = (errors) => errors.some((e) => e.workflowKey !== undefined || e.pageSize !== undefined);
export function buildQueryPageSizeMap(rows) {
    const errors = validateQueryPageSizeRows(rows);
    const map = {};
    rows.forEach((row, i) => {
        if (isBlankRow(row) || errors[i].workflowKey || errors[i].pageSize)
            return;
        map[row.workflowKey.trim()] = Number(row.pageSize.trim());
    });
    return Object.keys(map).length > 0 ? map : undefined;
}
